import AdminDashboard from './admin';
import ClientDashboard from './client';
import ContractorDashboard from './contractor';

const tenants = {
    admin: AdminDashboard,
    client: ClientDashboard,
    contractor: ContractorDashboard
};

export default tenants;



// WEBPACK FOOTER //
// ./src/pages/dashboard/tenants/index.jsx